import MesoRegiaoList from './list';

export default function MesoRegiaoPage() {
  return <MesoRegiaoList />;
}
